export const COMPONENT_NAMESPACE = 'data-wp-component';
export const CONNECTED_NAMESPACE = 'data-wp-c16t';

/**
 * Special key where the connected namespaces are stored.
 * This is attached to Context connected components as a static property.
 */
export const CONNECT_STATIC_NAMESPACE = '__contextSystemKey__';
